import type { VisitRetentionPeriod } from "@/common/types/settingsOptions";
import type { TranscriptionLanguage } from "@/common/types/transcriptionLanguage";
import { getSettingsOptions } from "@/services/settingsOptions";
import { create } from "zustand";

export interface SettingsOptionsState {
  visitRetentionPeriods: VisitRetentionPeriod[];
  transcriptionLanguages: TranscriptionLanguage[];
  loading: boolean;
  error: boolean;
  fetch: () => Promise<void>;
}

export const useSettingsOptions = create<SettingsOptionsState>()((set) => ({
  visitRetentionPeriods: [],
  transcriptionLanguages: [],
  loading: false,
  error: false,
  fetch: async (): Promise<void> => {
    set({ loading: true, error: false });
    try {
      const settingOptions = await getSettingsOptions();
      set({
        visitRetentionPeriods: settingOptions.visitRetentionPeriods,
        transcriptionLanguages: settingOptions.transcriptionLanguages,
        loading: false,
      });
    } catch {
      set({ visitRetentionPeriods: [], loading: false, error: true });
    }
  },
}));
